import { useSelector, useDispatch } from "react-redux";
import {
  closeBanner,
  closeModal,
  openModal,
} from "../../features/openInModal/OpenInModalSlice";

export function useOpenInModal() {
  const { isOpen, title, sectionId, modalContent, banner } = useSelector((state) => state.openInModal);
  const dispatch = useDispatch();

  return {
    isOpen,
    title,
    sectionId,
    modalContent,
    showBanner: banner,
    openModal: () => dispatch(openModal()),
    closeModal: () => dispatch(closeModal()),
    closeBanner: () => dispatch(closeBanner()),
  };
}
